import i18n from './index';

/**
 * Übersetzen AUSSERHALB von React (services/, lib/, stores/).
 *
 * WICHTIG: niemals auf Modulebene aufrufen — nur innerhalb von Funktionskörpern.
 * Auf Modulebene würde der Wert eingefroren, bevor die Sprache geladen ist.
 *
 *   // richtig
 *   export const getStatusLabel = (s: string) => t('domain:status.open', 'Offen');
 *   // falsch
 *   const LABEL = t('domain:status.open', 'Offen');
 *
 * In React-Komponenten UND Hooks stattdessen `useTranslation()` verwenden.
 */
export const t: typeof i18n.t = ((...args: unknown[]) =>
  (i18n.t as (...a: unknown[]) => string)(...args)) as typeof i18n.t;

export const currentLanguage = (): string => i18n.language;
